import _ from 'ckLodash';

function applyStyle(paramValue, styleToApply, blockElement) {
    if (blockElement.isReadOnly()) {
        return;
    }
    var isAddingStyle = paramValue !== CKEDITOR.TRISTATE_OFF;
    if (isAddingStyle) {
        blockElement.setStyle(styleToApply, paramValue);
    } else {
        blockElement.removeStyle(styleToApply);
    }
}

function propReduceFunc(res, value) {
    res[value] = true;

    return res;
}

function isSameStyleProperty(style, otherStyle) {
    var styleObj = _.reduce(style, propReduceFunc, {});
    var otherStyleObj = _.reduce(otherStyle, propReduceFunc, {});

    return _.isEqual(styleObj, otherStyleObj);
}

function haveNestedChild(parent) {
    return parent.tagName === 'SPAN' &&
        parent.childNodes &&
        parent.childNodes.length === 1 &&
        parent.childNodes[0].tagName === 'SPAN' &&
        isSameStyleProperty(parent.childNodes[0].style, parent.style);
}

function removeNestedStylesRecursive(root) {
    if (haveNestedChild(root)) {
        const nextRoot = root.childNodes[0];
        root.parentNode.insertBefore(root.childNodes[0], root);
        root.parentNode.removeChild(root);

        root = nextRoot;
        removeNestedStylesRecursive(root);
    }

    _.forEach(root.children, removeNestedStylesRecursive);
}

function removeNestedStyles(html) {
    var fragment = window.document.createElement('div');

    fragment.innerHTML = html;

    removeNestedStylesRecursive(fragment);

    return fragment.innerHTML;
}

export default {
    applyStyle: applyStyle,
    removeNestedStyles: removeNestedStyles
};
